<template>
    <div id="geraet">
        <h2>{{ geraet.name }}</h2>
        <div class="field right-aligned">
            <button @click="geraetBearbeiten()" class="fa">&#xf044;</button>
            <button @click="geraetLoeschen()" class="buttonDelete fa">&#xf1f8;</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    name: "Geraet",
    components: {},
    props: {
        geraet: Object,
    },
    data() {
        return {};
    },
    methods: {
        async geraetLoeschen() {
            await Swal.fire({
                title: "Gerät dauerhaft löschen?",
                showDenyButton: true,
                //showCancelButton: true,
                confirmButtonText: "Löschen",
                denyButtonText: `Nicht Löschen`
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.deleteGeraet();
                    //Swal.fire("Hydrant erfolgreich gelöscht", "", "success");
                } else if (result.isDenied) {
                    //Swal.fire("Changes are not saved", "", "info");
                }
            });
        },
        async deleteGeraet() {
            try {
                await axios.delete(
                    'https://feuerwehr-server.org:5000/deleteGeraet',
                    { params: { geraetID: this.$props.geraet.geraetID } }
                );
                this.deleteFile(this.$props.geraet.imagePath);
                Swal.fire("Gerät wurde erfolgreich gelöscht", "", "success");
                this.$emit('updateGeraetTable');
            } catch (err) {
                console.log(err);
                Swal.fire(
                    'Fehler beim Löschen!',
                    '',
                    'error'
                );
            };
        },
        async deleteFile(filePath) {
            try {
                const response = await fetch('https://feuerwehr-server.org:5000/delete-image', {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ filePath: filePath }) // Pfad der Datei senden
                });

                const result = await response.json();
                if (result.success) {
                    console.log('Datei erfolgreich gelöscht:', result.message);
                } else {
                    console.error('Fehler beim Löschen der Datei:', result.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        },
        async geraetBearbeiten(){
            var image = this.$props.geraet.imagePath;
            var html = "";
            html += `<img src="`+ image + `" style="height: 6rem"><br>`;
            html += `<input size="12" id="name" maxLength="50" class="swal2-input" placeholder="Bezeichnung" value="` + this.$props.geraet.name + `" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">`;
            html += `<input type="file" id="file" class="swal2-input" placeholder="Bild hochladen" value="` + image + `">`;

            const { value: formValues } = await Swal.fire({
                title: "Gerät bearbeiten",
                html: html,
                focusConfirm: false,
                preConfirm: () => {
                    var file = document.getElementById("file").files[0];
                    if(file == null){
                        file = image;
                    }
                    const name = document.getElementById("name").value;
                    return { name, file };
                }
            });

            if (formValues) {
                const file = formValues.file;
                const name = formValues.name;

                // FormData erstellen, um Bild zu senden
                const formData = new FormData();
                formData.append('file', file);

                // Upload der Datei ans Backend
                try {
                    if(file != image){
                        await this.deleteFile(this.$props.geraet.imagePath);
                    
                        const response = await fetch('https://feuerwehr-server.org:5000/upload-image-endpoint', {
                            method: 'POST',
                            body: formData
                        });

                        const result = await response.json(); // der Pfad oder das Ergebnis vom Backend
                        if (result.success) {
                            // Wenn der Upload erfolgreich war, Geraet anlegen
                            const imagePath = result.filePath; // Bildpfad vom Backend
                            await this.updateGeraet(name, imagePath, this.$props.geraet.geraetID); // Geraet mit Bildpfad erstellen
                            Swal.fire("Gerät wurde erfolgreich bearbeitet", "", "success");
                            this.$emit('updateGeraetTable');
                        }
                    } else{
                        await this.updateGeraet(name, image, this.$props.geraet.geraetID); // Geraet mit Bildpfad erstellen
                        Swal.fire("Gerät wurde erfolgreich bearbeitet", "", "success");
                        this.$emit('updateGeraetTable');
                    }
                } catch (error) {
                    console.error('Error uploading the file:', error);
                }
            }
        },
        async updateGeraet(name, imagePath, geraetID){
            const geraetData = {
                name: name,
                imagePath: imagePath,
                geraetID: geraetID,
                geraetID: geraetID
            }

            console.log(geraetData);
                const response = await axios.put('https://feuerwehr-server.org:5000/updateGeraet', geraetData);
            try{

            } catch (err){
                console.log(err);
            }
        }
    },
    created() {
        
    },
};
</script>

<style lang="scss">
#geraet {
    //font-size: x-large;
    display: flex;
    justify-content: space-between;
    margin-left: 10%;
    margin-right: 10%;
    background-color: white;
    border: solid black 0.2rem;
    margin-bottom: -0.1rem;
    padding: 0.3rem;
    padding-left: 3rem;
    word-wrap:normal;

    @media (max-width: 768px) {
        padding-left: 0rem;
        flex-direction: column;
        align-items: center;

        h2{
            margin-bottom: 0px;
        }

        .field {
            width: auto !important;
        }
    }
}
</style>
